// extracted by css-extract-rspack-plugin
export default {"appointmentSelector":"appointmentSelector-efL9P7"};